<script lang="ts">
  import { selectedOrgStore } from "$lib/stores/orgs";
  import SectionTitle from "$lib/components/shared/SectionTitle.svelte";
  import LoadingSpinner from "$lib/ui/loading-spinner/loading-spinner.svelte";

  $: org = $selectedOrgStore;
</script>

<SectionTitle>Security</SectionTitle>
{#if org}
  <div class="flex flex-col-reverse xs:flex-row justify-between xs:items-center gap-4">
    <div class="card">
      {org.index.managed}
    </div>
  </div>
{:else}
  <LoadingSpinner />
{/if}
